import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { GlobalStyles } from './GlobalStyles';
import ThemeProvider from './common/provider/ThemeProvider';
import App from './App';
import i18n from './i18next';
import './index.css';
import { HelmetProvider } from 'react-helmet-async';
import { DialogProvider } from './common/context/DialogContext';
import { ErrorBoundary } from './components/error-boundary';

// Update HTML lang attribute based on current language
const updateHtmlLang = (lang) => {
  document.documentElement.setAttribute('lang', lang);
};

// Set initial language
updateHtmlLang(i18n.language);

// Update language when it changes
i18n.on('languageChanged', (lang) => {
  updateHtmlLang(lang);
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <ThemeProvider>
          <GlobalStyles />
          <BrowserRouter>
            <DialogProvider>
              <HelmetProvider>
                <App />
              </HelmetProvider>
            </DialogProvider>
          </BrowserRouter>
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// // Register service worker for image caching and offline support
// serviceWorkerRegistration.register({
//   onSuccess: () => {
//     logger.log('Service worker registered successfully. Images will be cached.');
//   },
//   onUpdate: (registration) => {
//     logger.log('New service worker available. Please refresh the page.');
//     // Optionally, you can show a notification to the user here
//   },
// });
